import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { getJobCandidateStage } from "../../helpers/backend_helper";
import { JOB_STAGE_IDS } from "../JobListing/JobListingConstants";

function RejectedPOV({
  jobId,
  candidateId,
  isRejectedPOVModalOpen,
  setIsRejectedPOVModalOpen,
}) {
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState();

  const handleClose = () => {
    setIsRejectedPOVModalOpen(false);
  };

  useEffect(() => {
    if (jobId && candidateId) {
      setLoading(true);
      getJobCandidateStage({
        jobId: jobId,
        candidateId: candidateId,
        jobStageId: JOB_STAGE_IDS?.RELEASE_PREOFFERVERIFICATION,
      })
        .then((res) => {
          setReason(
            res?.data?.submissionData?.notes ?? "Please check your email."
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [jobId, candidateId]);

  return (
    <Modal
      isOpen={isRejectedPOVModalOpen}
      toggle={setIsRejectedPOVModalOpen}
      centered
    >
      <ModalHeader className="bg-primary pb-1">
        <div className="d-flex flex-column text-dark">
          <span className="h5 fw-bold">Rejection Message</span>
        </div>
      </ModalHeader>
      <ModalBody>
        <div
          className="my-4 text-center"
          style={{ fontSize: "14px", fontWeight: "500" }}
        >
          {loading ? <Spinner size="sm" color="primary" /> : reason}
        </div>
      </ModalBody>
      <ModalFooter className="pt-0 pe-4 ps-4">
        <Button className="btn btn-light w-100" onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default RejectedPOV;
